import { render, staticRenderFns } from "./HumanCapital.vue?vue&type=template&id=69c578c9&scoped=true&"
import script from "./HumanCapital.vue?vue&type=script&lang=ts&"
export * from "./HumanCapital.vue?vue&type=script&lang=ts&"
import style0 from "./HumanCapital.vue?vue&type=style&index=0&id=69c578c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c578c9",
  null
  
)

export default component.exports